import {
    Directive,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    HostListener,
    TemplateRef,
  } from '@angular/core';
  import { Overlay, OverlayRef } from '@angular/cdk/overlay';
  import { TemplatePortal } from '@angular/cdk/portal';
  import { ViewContainerRef } from '@angular/core';
  
  @Directive({
    selector: '[appDropdownPosition]',
  })
  export class DropdownPositionDirective implements OnInit, OnDestroy {
    @Input('appDropdown') menuTemplate!: TemplateRef<any>;
    private overlayRef!: OverlayRef;
  
    constructor(
      private overlay: Overlay,
      private elementRef: ElementRef,
      private renderer: Renderer2,
      private viewContainerRef: ViewContainerRef
    ) {}
  
    ngOnInit() {
      // Create the overlay reference
      this.overlayRef = this.overlay.create({
        positionStrategy: this.getOverlayPosition(),
        scrollStrategy: this.overlay.scrollStrategies.reposition(),
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-transparent-backdrop',
      });
  
      // Attach event to close the menu on backdrop click
      this.overlayRef.backdropClick().subscribe(() => this.overlayRef.detach());
    }
  
    @HostListener('click', ['$event'])
    toggleMenu(event: Event) {
      event.stopPropagation();
  
      if (this.overlayRef && this.overlayRef.hasAttached()) {
        this.overlayRef.detach();
      } else {
        // Convert TemplateRef to TemplatePortal and attach it
        const portal = new TemplatePortal(
          this.menuTemplate,
          this.viewContainerRef
        );
        this.overlayRef.attach(portal);
      }
    }
  
    private getOverlayPosition() {
      const elementPosition =
        this.elementRef.nativeElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
  
      // Check if the element is below or above the middle of the screen
      const isBelowHalf = elementPosition.top < windowHeight / 2;
  
      // Create position strategy
      return this.overlay
        .position()
        .flexibleConnectedTo(this.elementRef)
        .withPositions([
          {
            originX: 'end',
            originY: isBelowHalf ? 'bottom' : 'top', // Open up or down based on the position
            overlayX: 'end',
            overlayY: isBelowHalf ? 'top' : 'bottom',
            offsetY: isBelowHalf ? 0 : -100, // Adjust offset to avoid visual overlap
          },
        ]);
    }
  
    ngOnDestroy() {
      if (this.overlayRef) {
        this.overlayRef.dispose();
      }
    }
  }
  